import pricingContextModuleHelpers from '@vp/pricing-context-module/helpers';

const getPricingContext = () => {
  const pricingContext = pricingContextModuleHelpers.getPcxtV3()?.getPricingContext();
  return pricingContext ?? {};
};
const isPricingContextInitialized = () => {
  return pricingContextModuleHelpers.getPcxtV3()?.isInitialized() ?? false;
};
const getPricingContextVatInclusivity = () => {
  const isVatInclusive = pricingContextModuleHelpers.getPcxtV3()?.isVatInclusive();
  return isVatInclusive ?? false;
};
const initializePricingContext = (tenant, market, callback) => {
  try {
    pricingContextModuleHelpers.initializePricingContext({
      merchantId: tenant,
      market,
      isDevelopmentMode: true
    });
    document.addEventListener(
      pricingContextModuleHelpers.EVENTS.INITIALIZED_EVENT,
      callback
    );
  } catch (error) {
    console.error("Failed to initialize pricing context:", error);
  }
};

export { getPricingContext, getPricingContextVatInclusivity, initializePricingContext, isPricingContextInitialized };
//# sourceMappingURL=src-utils-pricingContext.util.js.map
